<template>
  <div
    ref="menuEl"
    class="d-flex align-items-center gap-8 cursor-pointer dropdown-toggle after-none position-relative i18n-menu mr-20 px-20"
    :class="{ 'd-none': isHidden }"
    :style="{ 'border-right': isDarkMode ? '1px solid #ffffff33' : '1px solid rgba(0, 54, 91, 0.2)' }"
  >
    <div
      data-mdb-toggle="dropdown"
      data-mdb-display="static"
      data-mdb-reference="parent"
      data-mdb-dropdown-animation="off"
      class="d-flex align-items-center gap-8"
    >
      <span ref="labelEl" class="fs-14" :class="{ 'text-white': isDarkMode }">{{ currentLabel }}</span>
      <img
        src="../../../assets/icons/arrow-down.svg"
        alt="down"
        class="icon-14 dropdown-icon"
        :style="{ 'filter': isDarkMode ? 'brightness(0) invert(1)' : 'none' }"
      />
    </div>

    <ul
      class="dropdown-menu dropdown-menu-end b-r-4 top-32"
      style="box-shadow: 0 10px 48px 0 #00365b33; padding: 0.5rem 0"
    >
      <li class="d-flex flex-wrap">
        <a
          class="d-flex gap-16 align-items-center text-00365b entry"
          :class="{ 'entry-active': currentLang === 'ja' }"
          style="padding: 0.5rem 1.5rem"
          data-lang="ja"
          @click="switchLanguage('ja')"
        >
          <div class="flex-grow-1" style="width: 5rem">日本語</div>
          <img src="../../../assets/icons/check-fill.svg" alt="avatar" class="w-16 h-16 check-icon" />
        </a>

        <a
          class="d-flex gap-16 align-items-center text-00365b entry"
          :class="{ 'entry-active': currentLang === 'en' }"
          style="padding: 0.5rem 1.5rem"
          data-lang="en"
          @click="switchLanguage('en')"
        >
          <div class="flex-grow-1" style="width: 5rem">English</div>
          <img src="../../../assets/icons/check-fill.svg" alt="avatar" class="w-16 h-16 check-icon" />
        </a>

        <a
          class="d-flex gap-16 align-items-center text-00365b entry"
          :class="{ 'entry-active': currentLang === 'zh' }"
          style="padding: 0.5rem 1.5rem"
          data-lang="zh"
          @click="switchLanguage('zh')"
        >
          <div class="flex-grow-1" style="width: 5rem">简体中文</div>
          <img src="../../../assets/icons/check-fill.svg" alt="avatar" class="w-16 h-16 check-icon" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import Cookies from 'js-cookie'

const props = defineProps({
  isDarkMode: {
    type: Boolean,
    default: false
  }
})

const { locale } = useI18n()
const currentLang = ref('')
const isHidden = ref(true)
const currentLabel = computed(() => {
  if (currentLang.value === 'ja') return '日本語'
  if (currentLang.value === 'en') return 'English'
  if (currentLang.value === 'zh') return '简体中文'
  return '日本語'
})

const switchLanguage = (lang) => {
  currentLang.value = lang
  locale.value = lang
  localStorage.setItem('SCANAT_LANG', lang)
  Cookies.set('language', lang)
  
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: { lang } }))
  
  // 更新页面语言
  const iframeEl = document.querySelector('.model-body-container')
  iframeEl?.contentWindow?.postMessage(
    { name: 'lang', lang: lang === 'zh' ? 'cn' : lang, type: 'modelData' },
    '*'
  )
}

const setPageLang = () => {
  const lang = localStorage.getItem('SCANAT_LANG') || Cookies.get('language') || 'ja'
  currentLang.value = lang
  locale.value = lang
  isHidden.value = false
}

onMounted(() => {
  setPageLang()
})
</script>

<style scoped>
</style> 